import { TriangleAlert } from "lucide-react";
import { useTranslation } from "react-i18next";

/**
 * Anti-recommendation card. The title uses `titleLocale` (the diagnostic's locale,
 * i.e. the group's language) : NOT the user's UI language. Other labels follow UI lang.
 */
export default function AntiRecoCard({ atelier, raisonnement, testId, titleLocale }) {
  const { i18n, t } = useTranslation();
  if (!atelier) return null;
  const uiLocale = (i18n.language || "fr").startsWith("en") ? "en" : "fr";
  const tLoc = titleLocale === "en" ? "en" : "fr";
  const title = tLoc === "en"
    ? (atelier.title_en || atelier.title_fr || atelier.id)
    : (atelier.title_fr || atelier.title_en || atelier.id);
  const doNotLabel = uiLocale === "en" ? t("diag.do_not") : "À NE PAS faire";
  return (
    <div
      className="relative bg-bg-soft border border-danger/30 rounded-xl p-4 md:p-5"
      data-testid={testId || `anti-reco-${atelier.id}`}
    >
      <div className="flex items-start gap-3">
        <div className="flex-shrink-0 w-9 h-9 rounded-full bg-danger/10 flex items-center justify-center">
          <TriangleAlert className="w-4 h-4 text-danger" strokeWidth={2.2} />
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 mb-1">
            <span className="font-mono text-xs px-2 py-0.5 rounded bg-white border border-border text-text-secondary">
              {atelier.id}
            </span>
            <span className="text-xs uppercase tracking-wider font-bold text-danger">{doNotLabel}</span>
          </div>
          <h4 className="font-heading font-bold text-base text-text-primary mb-1">{title}</h4>
          <p className="text-sm text-text-secondary leading-relaxed">{raisonnement}</p>
        </div>
      </div>
    </div>
  );
}
